import React from "react";
import AVLPageContainer from "../containers/AVLPageContainer";
const AVLPage = (props) => {
    return (React.createElement(AVLPageContainer, null));
};
export default AVLPage;
